import React from 'react';
import LoadImage from 'components/common/loadImage/loadImage';
import { ContainerModalInternal, Header, Footer } from 'components/styles/Common.styled';
import MenuModalWithActiveItem from 'components/common/MenuModalWithActiveItem';
import { PortalContainer, PortalContainerDisplay } from 'components/styles/Portal.styled';
import BackCursor from 'components/common/nav/backCursor';
import { translate as t } from 'utils/i18n';

/**
 * Original Portal Menu Template Component
 * This is a presentation component that receives all data via props
 */
const PortalMenuTemplate = ({
  categories,
  profile,
  showError,
  isLoading,
  focusIndex,
  onItemClick,
}) => {
  return (
    <div>
      <Header></Header>
      <BackCursor></BackCursor>
      <PortalContainer>
        {!profile && !showError && isLoading ? (
          <div className={`has-text-danger has-text-centered`}>
            <p className={'is-size-4 has-text-bold has-text-centered'}>
              {t('Portal.portal_error')}
            </p>
          </div>
        ) : !profile && showError && !isLoading ? (
          <div className={`has-text-danger has-text-centered`}>
            <p className={'is-size-4 has-text-bold'}>
              The selected language is not configured yet.
            </p>
          </div>
        ) : (
          profile && (
            <ContainerModalInternal>
              <PortalContainerDisplay>
                <div className='portal-content-layout'>
                  <div style={{ overflow: 'hidden' }} className='portal-image-align'>
                    <LoadImage
                      image_url={profile.image}
                      width={'100%'}
                      height={'100%'}
                    />
                  </div>
                  <div className='portal-description'>
                    <p>{profile.category_title + ' : ' + profile.locale_description}</p>
                  </div>
                </div>
              </PortalContainerDisplay>
            </ContainerModalInternal>
          )
        )}
      </PortalContainer>
      {categories.length > 0 && !showError && (
        <Footer>
          <MenuModalWithActiveItem
            items={categories.map((item) => ({
              text: item.category_title,
              id: item.id,
              active: item.active,
            }))}
            activeIndex={focusIndex}
            onItemClick={onItemClick}
            showImages={false}
          />
        </Footer>
      )}
    </div>
  );
};

export default PortalMenuTemplate;
